module.exports = __webpack_public_path__ + "img/9.03d54401.jpg";